module.exports = __webpack_public_path__ + "img/company29.2f403573.png";